import FillArrowIcon from 'components/icons/fill-arrow/'
import MyfontsShortCircleIcon from 'components/icons/myfonts-short-circle/'
import FouSlider from 'components/tools/fou-slider/'
import FouModal from 'components/overlay/fou-modal/'
import FouContainer from 'components/tools/fou-container/'
import FouPicture from 'components/tools/fou-picture/'
import FouSelect from 'components/form/fou-select'
import FouSelectTags from 'components/form/fou-select-tags/'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import TrashIcon from 'components/icons/trash/'
import Externalsku from './../../upload/externalsku'
import TextField from 'src/components/form/text-field/index.vue'
import VSelect from 'src/components/form/v-select/index.vue'
import Loader from 'src/components/animations/processing.vue'

export default {
  FouSlider,
  FouModal,
  FouContainer,
  FouSelect,
  FouSelectTags,
  FouPicture,
  FillArrowIcon,
  MyfontsShortCircleIcon,
  ...FouGrid,
  FouGroup,
  Externalsku,
  TrashIcon,
  TextField,
  VSelect,
  Loader
}
